import { useAssistantChat } from '../../api/getChat';
import { useChatStore } from '../../stores/chatStore';

import type { CSSProperties } from 'react';

const ToggleStyle: CSSProperties = {
  alignSelf: 'flex-start',
  padding: '0.5rem 1rem',
  background: '#333',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
};

export const ChatDebugger = () => {
  const { mutate: sendMessage } = useAssistantChat();
  const addMessage = useChatStore.use.sendMessage();
  const addAIResponse = useChatStore.use.addAIResponse();
  const isSidebarOpen = useChatStore.use.isSidebarOpen();
  const setSidebarOpen = useChatStore.use.setSidebarOpen();

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  const startChat = () => {
    addMessage(
      `Hi, my name is Tester. I would like to set up my personal profile. I'm a management consultant. My age is 30, income is 5000, expense is 2000, and I have a savings of 10000. I work alone. I don't have a partner or kids. I have a house worth 600000 with surplus value of 200000. I am interested in health insurance and life insurance. `,
    );
    sendMessage({
      message: `Hi, my name is Tester. I would like to set up my personal profile. I'm a management consultant. My age is 30, income is 5000, expense is 2000, and I have a savings of 10000. I work alone. I don't have a partner or kids. I have a house worth 600000 with surplus value of 200000. I am interested in health insurance and life insurance.`,
    });
  };

  const debugMarkdown = () => {
    const message = `# Lorem Ipsum Documentation

  ## Overview
  Lorem ipsum dolor sit amet, **consectetur adipiscing elit**, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. *Ut enim ad minim veniam*, quis nostrud exercitation ullamco laboris.

  ### Key Features
  - Lorem ipsum dolor sit amet
  - Consectetur adipiscing elit
  - Sed do eiusmod tempor incididunt
  - Ut labore et dolore magna aliqua

  #### Implementation Details
  1. First step: Lorem ipsum dolor sit amet
  2. Second step: Consectetur adipiscing elit
  3. Third step: Sed do eiusmod tempor
  4. Final step: Incididunt ut labore

  > **Important Note:** Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.

  ##### Code Examples

  \`\`\`javascript
  function loremIpsum() {
    const text = "Lorem ipsum dolor sit amet";
    console.log(text);
    return text;
  }
  \`\`\`

  ###### Configuration Options

  | Option | Type | Default | Description |
  |--------|------|---------|-------------|
  | \`lorem\` | string | "ipsum" | Lorem ipsum dolor sit |
  | \`dolor\` | boolean | true | Sit amet consectetur |
  | \`elit\` | number | 42 | Sed do eiusmod tempor |

  ~~Deprecated functionality~~ has been replaced with modern alternatives.

  ---

  **Bold text** and *italic text* can be combined as ***bold italic text***.

  \`Inline code\` examples: \`const lorem = "ipsum";\`

  [Lorem Ipsum Link](https://example.com) for more information.

  ![Alt text for image](https://via.placeholder.com/150)

  > ### Blockquote Header
  > Lorem ipsum dolor sit amet, consectetur adipiscing elit.
  >
  > > Nested blockquote: Sed do eiusmod tempor incididunt.

  - [ ] Unchecked task
  - [x] Completed task
  - [ ] Another unchecked task

  ##### Mathematical Expressions
  E = mc²

  ###### Additional Notes
  Lorem ipsum dolor sit amet, consectetur :smile: adipiscing elit.

  ---

  **Final Summary:** Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.`;

    addAIResponse({ response: message });
  };

  const debugShortMarkdown = () => {
    const message = `# Markdown Test

Hello 🖐️, this is a test of the markdown parser. Pixi'VN does not manage markdown, but you can implement a markdown parser to display text with markdown syntax.

For example in React, you can use the library [react-markdown](https://www.npmjs.com/package/react-markdown).

## Colored Text

<span style="color:blue">some *blue* text</span>.

<span style="color:red">some *red* text</span>.

<span style="color:green">some *green* text</span>.

## Bold Text

**This is bold text.**

## Italic Text

*This is italic text.*

## Delete Text

~~This is deleted text.~~

## Link Test

[Link to Google](https://www.google.com)

## H2 Test

### H3 Test

#### H4 Test

## Code Test

\`Hello World\`

\`\`\`js
console.log("Hello World")
\`\`\`

## List Test

- Item 1
- Item 2
- [x] Item 3

## Table Test

| Header 1 | Header 2 |
| -------- | -------- |
| Cell 1   | Cell 2   |

## Image Test

![Image](https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkw_mXXQ9FJ9HgmW_B9QMv-gvOmndUaEI9SA&s)
`;

    addAIResponse({ response: message });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '2px',
        fontSize: '14px',
        fontWeight: 500,
        color: '#000',
        background: 'rgba(255,255,255,0.85)',
        padding: '4px 8px',
        borderRadius: '8px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.12)',
        position: 'absolute',
        top: '30px',
        left: '16px',
        zIndex: 1000,
      }}
    >
      <h3>Debug</h3>

      <button style={ToggleStyle} onClick={toggleSidebar}>
        Toggle Sidebar
      </button>
      <button style={ToggleStyle} onClick={startChat}>
        Start Chat
      </button>
      <button style={ToggleStyle} onClick={debugMarkdown}>
        Debug Markdown
      </button>
      <button style={ToggleStyle} onClick={debugShortMarkdown}>
        Debug Short Markdown
      </button>
    </div>
  );
};
